export const SET_IMPORTED_FILE_DATA = 'SET_IMPORTED_FILE_DATA';
export const setImportedFileData = (data) => ({
    type: SET_IMPORTED_FILE_DATA,
    payload: data
});
